export default function WebinarDetailJumbotron() {
}

(() => {
  const countdown = document.querySelector(".jumbotron_countdown");
  if (!(countdown instanceof Element)) return;
  
  const startDate = countdown.dataset.startDate;
  
  const update = () => {
    const now = Math.floor(new Date().getTime() / 1000);
    const t = startDate - now;
  
    if (t <= 0) {
      window.clearInterval(timer);
      return;
    }
  
    const mapping = {
      ".js-days": Math.floor(t / (60 * 60 * 24)),
      ".js-hours": Math.floor(t / (60 * 60)) % 24,
      ".js-minutes": (Math.floor(t / 60) % 60).toString().padStart(2, "0"),
      ".js-seconds": (t % 60).toString().padStart(2, "0"),
    };
  
    Object.entries(mapping).forEach(([selector, value]) => {
      countdown.querySelectorAll(selector).forEach(el => {
        el.innerHTML = value;
      })
    });
  };
  
  const timer = window.setInterval(update, 1000);
  update();
})();
